var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{active: _vm.active},attrs:{"id":"accountModal"}},[_c('h2',[_vm._v("Account Modal")])])}
var staticRenderFns = []

export { render, staticRenderFns }